module.exports = __webpack_public_path__ + "media/images/top-service-01-33912089c0061a597325ff6ed7d2d56e.jpg";